import { render, staticRenderFns } from "./Part-Object.vue?vue&type=template&id=09981e78"
import script from "./Part-Object.vue?vue&type=script&setup=true&lang=js"
export * from "./Part-Object.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09981e78')) {
      api.createRecord('09981e78', component.options)
    } else {
      api.reload('09981e78', component.options)
    }
    module.hot.accept("./Part-Object.vue?vue&type=template&id=09981e78", function () {
      api.rerender('09981e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tables/formats/Part-Object.vue"
export default component.exports